import { StatementType } from './statement-types';

export const SpanishStatements: Record<StatementType, string[]> = {
  annoyed: [
    '¿Acaso no te lo dije ayer?',
    '¡No creas que no he estado prestando atención!',
    '¡No puedo pensar con este ruido!',
    '¿Tan pasivo-agresivo eres?',
    '¡Sabes que eso no va ahí!',
    '¡Han pasado 7 horas y 15 días desde que te llevaste mi cortacésped!',
    '¿Tienes que masticar tan fuerte?',
    '¡Solo tómalo ya!',
    'Si no tienes nada bueno que decir, ¡no digas nada!',
    'Vámonos ya.',
  ],
  frustrated: [
    '¡Pues hazlo a tu manera entonces!',
    '¡Nunca voy a entender esto!',
    '¡La página web no carga!',
    '¡Esta lata no se abre!',
    '¡No puedes abrirlo así!',
    '¡Siempre tienes que tener la última palabra!',
  ],
  angry: [
    '¿¡QUÉ DEMONIOS CREES QUE ESTÁS HACIENDO!?',
    '¡Hijo bastardo de una víbora taciturna!',
    '¡Voy a matarte!',
    'No, estás equivocado.',
    '¡Se suponía que debías protegernos!',
  ],
  random: [
    '¡Los gansos vienen! ¡Los gansos vienen!',
    'Las batatas no son ni dulces ni papas.',
    '¡Muy bien entonces! ¡Yalla!',
    '¿Jamás dejarán de ocurrir milagros?',
    '"¡Vaya, eso son muchos arándanos!"',
    '¡Caramba!',
    '¿Seguro que quieres hacer eso?',
    '¡Señor, ten piedad!',
    'El cielo está tan azul hoy.',
    'No le tengo miedo a ningún fantasma.',
    'Supongo que no sabes cocinar, ¿verdad?',
    'Calmémonos todos y respiremos profundo.',
    'El amor es la respuesta.',
  ],
  child: [
    '¡Ja ja!',
    '¡No lo bastante rápido!',
    '¡Vaya!',
    '¡VIEJO!',
    'jajaja',
    '¡Weeee!',
    '¿Ya quieres rendirte?',
    '¡Mira esto!',
    '¿Te estás cansando?',
    '¡Con permiso!',
    '¡Cuidado!',
  ],
  'child-no': ['¡No!'],
  'stay-near-me': ['Quédate cerca de mí, no te alejes.'],
};
